export const ReceiptProductTypeEnum = {
  HOTEL: 'hotel',
  EXPERIENCE: 'experience',
  EXTRA: 'extra',
};
